"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGradientUnits = exports.StyledGradient = exports.StyledLegendToggle = exports.StyledClosedLegend = exports.StyledConfigItemColor = exports.StyledLegendConfigItem = exports.StyledLegendConfig = exports.StyledLegendLayerWrapper = exports.StyledLegendTitle = exports.StyledLegend = exports.StyledCaption = exports.StyledMapContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledMapContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledMapContainer",
  componentId: "sc-1m7dm1p-0"
})(["display:flex;height:100%;width:100%;min-height:inherit;.map-leaflet{z-index:1;display:flex;width:100%;}"]);

exports.StyledMapContainer = StyledMapContainer;

var StyledCaption = _styledComponents["default"].p.withConfig({
  displayName: "styles__StyledCaption",
  componentId: "sc-1m7dm1p-1"
})(["position:absolute;z-index:2;color:#fff;font-size:21px;transform:translate(15px,15px);max-width:85%;"]);

exports.StyledCaption = StyledCaption;

var StyledLegend = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledLegend",
  componentId: "sc-1m7dm1p-2"
})(["position:absolute;z-index:2;bottom:0;right:0;background:#fff;transform:translate(-15px,-30px);width:310px;min-height:40px;border-radius:5px 0 5px 5px;"]);

exports.StyledLegend = StyledLegend;

var StyledLegendTitle = _styledComponents["default"].h5.withConfig({
  displayName: "styles__StyledLegendTitle",
  componentId: "sc-1m7dm1p-3"
})(["color:#393f44;font-size:14px;padding:10px;"]);

exports.StyledLegendTitle = StyledLegendTitle;

var StyledLegendLayerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledLegendLayerWrapper",
  componentId: "sc-1m7dm1p-4"
})(["max-height:140px;overflow-y:scroll;"]);

exports.StyledLegendLayerWrapper = StyledLegendLayerWrapper;

var StyledLegendConfig = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledLegendConfig",
  componentId: "sc-1m7dm1p-5"
})(["color:red;"]);

exports.StyledLegendConfig = StyledLegendConfig;

var StyledLegendConfigItem = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledLegendConfigItem",
  componentId: "sc-1m7dm1p-6"
})(["color:#393f44;display:flex;align-items:center;padding:0 10px;margin-bottom:10px;font-size:12px;font-weight:600;"]);

exports.StyledLegendConfigItem = StyledLegendConfigItem;

var StyledConfigItemColor = _styledComponents["default"].span.withConfig({
  displayName: "styles__StyledConfigItemColor",
  componentId: "sc-1m7dm1p-7"
})(["display:block;margin:0 5px 0 0;width:12px;height:12px;", ""], function (props) {
  return props.hexCode && (0, _styledComponents.css)(["background:", ";"], props.hexCode);
});

exports.StyledConfigItemColor = StyledConfigItemColor;

var StyledClosedLegend = _styledComponents["default"].h5.withConfig({
  displayName: "styles__StyledClosedLegend",
  componentId: "sc-1m7dm1p-8"
})(["color:#393f44;font-size:11px;text-transform:uppercase;line-height:40px;padding:0 10px;"]);

exports.StyledClosedLegend = StyledClosedLegend;

var StyledLegendToggle = _styledComponents["default"].button.withConfig({
  displayName: "styles__StyledLegendToggle",
  componentId: "sc-1m7dm1p-9"
})(["position:absolute;display:flex;align-items:center;justify-content:center;cursor:pointer;background:hsla(0,0%,44.3%,0.8);width:40px;height:32px;top:-32px;border:none;outline:none;right:0;border-radius:5px 5px 0 0;", " svg{fill:#fff;width:14px;height:14px;}"], function (props) {
  return !props.legendOpen && (0, _styledComponents.css)(["svg{transform:rotate(180deg);}"]);
});

exports.StyledLegendToggle = StyledLegendToggle;

var StyledGradient = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledGradient",
  componentId: "sc-1m7dm1p-10"
})(["", " height:7px;width:calc(100% - 20px);margin:0 10px 7px 10px;box-sizing:border-box;"], function (props) {
  return props.items && (0, _styledComponents.css)(["background:linear-gradient(90deg,", ");"], props.items.join(","));
});

exports.StyledGradient = StyledGradient;

var StyledGradientUnits = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledGradientUnits",
  componentId: "sc-1m7dm1p-11"
})(["position:relative;height:20px;display:flex;justify-content:space-between;> div:first-child{text-align:left;}> div:last-child{text-align:right;}"]);

exports.StyledGradientUnits = StyledGradientUnits;